import React from "react";
import PropTypes from "prop-types";

import Loading from "./Loading.js";

const Suspense = props => (
  <React.Suspense fallback={<Loading {...props.loadingProps} />}>
    {props.children}
  </React.Suspense>
);

Suspense.propTypes = {
  loadingProps: PropTypes.object,
  children: PropTypes.node.isRequired,
};

Suspense.defaultProps = {loadingProps: {delay: 0}};

Suspense.displayName = "Suspense";

export default Suspense;
